<template>
    <div class="elite-prospects-player">
        <transition name="dialogfade">
            <k-dialog v-if="showDialog" class="default__dialog elite-prospects-player-dialog">
                <div class="icon__container">
                    <i class="fa-solid fa-people-group"></i>
                </div>
                <div class="header__container">
                    <svg viewBox="0 0 300 55" x="0px" y="0px" xml:space="preserve" fill="none" xmlns="http://www.w3.org/2000/svg" style="enable-background:new 0 0 300 35;"><path fill-rule="evenodd" class="icon__top-bar" clip-rule="evenodd" d="M290,21.74H169.3a19.32,19.32,0,0,1-38.64,0H10c-5.52,0-10,2.53-10,5.66V50H300V27.4C300,24.27,295.52,21.74,290,21.74Z" transform="translate(0 -21.74)" fill="#D4B139"></path></svg>
                </div>
                <div class="elite-prospects-player__header">
                    <h1 class="dialog--title">IceProspects Player Search</h1>
                </div>
                <div class="upsert-item__container ep-player">
                    <div class="ep-player-body">
                        <div class="upsert-item__section">
                            <elite-prospects-search-component :detail-dialog-view="false" @playerselected="getEPPlayerById" />
                            <h2 class="upsert-item__section--title">Current Selection</h2>
                            <elite-prospects-player-data-component :selected-ep-Player="selectedEPPlayer" />
                        </div>
                    </div>
                    <k-action-bar>
                        <k-button class="item-save__btn" :disabled="selectPlayerBtnDisabled" @click="onPlayerSelected">Select Player</k-button>
                        <k-button class="item-cancel__btn" @click="onCancelClicked">Close</k-button>
                    </k-action-bar>
                </div>
            </k-dialog>
        </transition>

        <div class="loader-container" v-if="isLoading">
            <k-loader :size="'large'" :type="'infinite-spinner'"></k-loader>
        </div>

        <transition name="dialogfade">
            <k-dialog v-if="showErrorDialog" :title="errorTitle" class="error__dialog" @close="toggleErrorDialog">
                <p class="error-dialog__msg">{{ errorMsg }}</p>
            </k-dialog>
        </transition>
    </div>
</template>

<script>
    import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
    import { Button } from "@progress/kendo-vue-buttons";
    import { Loader } from "@progress/kendo-vue-indicators";

    import eliteProspectsSearchComponent from './eliteProspectsSearchComponent.vue';
    import eliteProspectsPlayerDataComponent from '../components/eliteProspectsPlayerDataComponent.vue';

    import auth from '../authConfig';
    import apiService from '../api/api.service.js';

    export default {
        name: 'eliteProspectsPlayerDialog',
        props: ['epPlayerId', 'showDialog'],
        emits: ['dialogclosed', 'playerselected'],
        data() {
            return {
                errorMsg: '',
                errorTitle: '',
                isLoading: false,
                selectedEPPlayer: null,
                showErrorDialog: false
            }
        },
        computed: {
            selectPlayerBtnDisabled() {
                return !this.selectedEPPlayer || this.selectedEPPlayer.id === this.epPlayerId;
            }
        },
        watch: {
            showDialog(val) {
                if (val) {
                    this.selectedEPPlayer = null;
                    if (this.epPlayerId) {
                        this.getEPPlayerById(this.epPlayerId)
                    }
                }
            }
        },
        methods: {
            async getEPPlayerById(playerId) {
                this.selectedEPPlayer = null;

                let self = this;
                this.isLoading = true;

                let tokenResponse = await auth.acquireTokenResponse();

                return apiService.EPGetPlayerById(tokenResponse.accessToken, playerId)
                    .then((res) => {
                        self.selectedEPPlayer = res.data?.data?.data;

                        self.isLoading = false;
                    }).catch(error => {
                        console.log(error);
                        self.onRequestError('An Error Occurred', error?.response?.data?.message);
                    })
            },
            onCancelClicked() {
                this.$emit('dialogclosed');
            },
            onPlayerSelected() {
                this.$emit('playerselected', this.selectedEPPlayer);
            },
            onRequestError(errorTitle, errorMsg) {
                this.isLoading = false;

                this.errorTitle = errorTitle;

                if (errorMsg) {
                    this.errorMsg = errorMsg;
                } else {
                    this.errorMsg = 'Please try again';
                }

                this.showErrorDialog = true;
            },
            toggleErrorDialog() {
                this.showErrorDialog = !this.showErrorDialog;

                if(!this.showErrorDialog) {
                    this.errorTitle = '';
                    this.errorMsg = '';
                }
            }
        },
        components: {
            'k-dialog': Dialog,
            'k-action-bar': DialogActionsBar,
            'k-button': Button,
            'k-loader': Loader,
            'elite-prospects-search-component': eliteProspectsSearchComponent,
            'elite-prospects-player-data-component': eliteProspectsPlayerDataComponent
        }
    }
</script>

<style>
    @import '/src/assets/css/defaultUpsertStyles.css';
    @import '/src/assets/css/eliteProspectsPlayerDialog.css';
</style>